import { Injectable } from '@angular/core';
import {
    SortType,
    SortDirection,
    PeopleSearchType
} from '../constants-types/Enums';
import { FilterInfo } from '../core-data-model/FilterInfo.model';
import { SortInfo } from '../core-data-model/SortInfo.model';
import {
    ODataQueryGeneratorService,
    KeyValue,
    UnknownFilterTypeError
} from '../core-services/ODataQueryGenerator.service';

@Injectable({ providedIn: 'root' })
export class PeopleAndJobsQueryGeneratorService extends ODataQueryGeneratorService {
    createSearch(
        searchText: string,
        resultsCount = 5,
        filters: FilterInfo[] = [],
        searchType: PeopleSearchType = PeopleSearchType.All
    ) {
        const keyValuePairs = [];
        keyValuePairs.push(
            ...this.getResultsSize(resultsCount),
            ...this.getSearchStringParameters(searchText, searchType),
            ...this.getFilterParameters(filters)
        );
        return this.combineParameters(keyValuePairs);
    }

    // TODO: Refactor code below. Similar code at other place
    private getSearchStringParameters(
        searchText: string,
        searchType: PeopleSearchType = PeopleSearchType.All
    ): KeyValue[] {
        let searchTypeValue = '';
        if (
            searchType === PeopleSearchType.SortName ||
            searchType === PeopleSearchType.Name ||
            searchType === PeopleSearchType.All
        ) {
            searchTypeValue += 'peopleAndJobsSearchResult/sortName,';
        }
        if (
            searchType === PeopleSearchType.FirstName ||
            searchType === PeopleSearchType.Name ||
            searchType === PeopleSearchType.All
        ) {
            searchTypeValue +=
                'peopleAndJobsSearchResult/assessmentUser/firstName,';
        }
        if (
            searchType === PeopleSearchType.LastName ||
            searchType === PeopleSearchType.Name ||
            searchType === PeopleSearchType.All
        ) {
            searchTypeValue +=
                'peopleAndJobsSearchResult/assessmentUser/lastName,';
        }
        if (
            searchType === PeopleSearchType.Email ||
            searchType === PeopleSearchType.All
        ) {
            searchTypeValue +=
                'peopleAndJobsSearchResult/assessmentUser/email,';
        }
        return [
            {
                key: '$search',
                value: searchText
            },
            {
                key: 'searchfields',
                value: searchTypeValue.slice(0, searchTypeValue.length - 1)
            }
        ];
    }

    private getResultsSize(size: number) {
        return [
            {
                key: '$top',
                value: size
            }
        ];
    }

    getOrderbyParameter(sortingState: SortInfo[]): KeyValue[] {
        // Unsupported sorts
        const unsupportedSorts = [SortType.Folder];
        const sortList = sortingState
            .filter((sortInfo) => !unsupportedSorts.includes(sortInfo.sortType))
            .map((sortInfo: SortInfo) => {
                let oDataSort;
                const oDataDirection =
                    sortInfo.direction === SortDirection.Ascending
                        ? 'asc'
                        : 'desc';
                switch (sortInfo.sortType) {
                    case SortType.RecentlySent:
                        oDataSort =
                            'peopleAndJobsSearchResult/assessmentInformation/latestAssessmentEmailSentDate';
                        break;
                    case SortType.RecentlyCompleted:
                        oDataSort =
                            'peopleAndJobsSearchResult/assessmentInformation/latestAssessmentCompletedDate';
                        break;
                    case SortType.Name:
                        oDataSort = `peopleAndJobsSearchResult/sortName`;
                        break;
                    case SortType.LastUpdated:
                        oDataSort = `peopleAndJobsSearchResult/sortDate`;
                        break;
                    case SortType.PersonType:
                        oDataSort =
                            'peopleAndJobsSearchResult/assessmentUser/personType';
                        break;
                    case SortType.ReferenceProfile:
                        oDataSort =
                            'peopleAndJobsSearchResult/assessmentInformation/behavioralAssessmentInformation/originalReferencePatternName';
                        break;
                    case SortType.RecentlyModifiedJob:
                        oDataSort =
                            'peopleAndJobsSearchResult/jobInformation/lastModifiedDate';
                        break;
                    case SortType.Favorite:
                        oDataSort =
                            'peopleAndJobsSearchResult/assessmentUser/impression';
                        break;
                    case SortType.AssociatedJob:
                        oDataSort = `peopleAndJobsSearchResult/isPerson desc, peopleAndJobsSearchResult/jobInformation/name`;
                        break;
                    default:
                        throw new UnknownFilterTypeError();
                }
                return `${oDataSort} ${oDataDirection}`;
            });
        if (sortList.length > 0) {
            return [
                {
                    key: '$orderby',
                    value: sortList.join(',')
                }
            ];
        }
        return [];
    }
}
